import { FieldWrapper } from '@td-client-frontend/common';
import clsx from 'clsx';
import React from 'react';

interface NewGroupModalContentProps {
  handleChange: (field: string, value: string) => void;
  setHasError: React.Dispatch<React.SetStateAction<boolean>>;
  hasError: boolean;
  newGroupName: string;
  newGroupNumber: string;
}

export const NewGroupModalContent = ({
  handleChange,
  setHasError,
  hasError,
  newGroupName,
  newGroupNumber
}: NewGroupModalContentProps) => {
  return (
    <section className="w-full p-6 overflow-y-auto font-bold">
      <div className="flex flex-col justify-center w-1/2">
        <FieldWrapper
          label="Group Name"
          name="newGroupName"
          isError={hasError}
          error={hasError && !newGroupName ? 'Required' : ''}
        >
          <input
            name="newGroupName"
            value={newGroupName}
            className={clsx(
              hasError && !newGroupName && 'border-danger focus:border-danger',
              'form-field overflow-hidden h-auto min-h-12 bg-white p-3'
            )}
            placeholder="Please enter group name"
            type="text"
            onChange={(e) => handleChange('NAME', e.target.value)}
          />
        </FieldWrapper>
        <FieldWrapper
          label="Group Number"
          name="newGroupNumber"
          isError={hasError}
          error={hasError && !newGroupNumber ? 'Required' : ''}
        >
          <input
            value={newGroupNumber}
            className={clsx(
              hasError && !newGroupNumber && 'border-danger focus:border-danger',
              'form-field overflow-hidden h-auto min-h-12 bg-white p-3'
            )}
            placeholder="Please enter group number"
            type="text"
            onChange={(e) => handleChange('NUMBER', e.target.value)}
          />
        </FieldWrapper>
      </div>
    </section>
  );
};
